import DateRange from '@/models/DateRange';

export default {

  state: {
    // fullScreen: false,
    dateRange: new DateRange(),
    appOptions: {
      removeAnomalies: true,
      standardDeviationFactor: 1,
    },
  },

  mutations: {

    SET_SENSOR_ANOMALIES(state, value) {
      state.appOptions.removeAnomalies = value;
    },

    SET_STD_DEV_FACTOR(state, value) {
      state.appOptions.standardDeviationFactor = value;
    },

    SET_DATE_RANGE(state, value) {
      state.dateRange = value;
    },

  },

};



// WEBPACK FOOTER //
// ./src/store/universal/index.js